import { RoleId, RoleIds } from '@efexteam/permission-manager';
import { IAddMemberSchema } from '@pages/teamMember/addTeamMember/schemas/addMember.schema';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const useAssignRole = ({
  canContinue,
}: {
  canContinue: (value: boolean) => void;
}) => {
  const { getValues, setValue } = useFormContext<Partial<IAddMemberSchema>>();
  const { email, userName } = getValues();

  const [roleId, setRoleId] = useState<RoleId>(RoleIds.PAYMENT_APPROVER);
  const [showAuthorizationTerms, setShowAuthorizationTerms] = useState(false);
  const [authorizationTerms, setAuthorizationTerms] = useState(false);

  useEffect(() => {
    setValue('roleId', roleId);

    canContinue(roleId !== RoleIds.PROMOTER);
  }, [roleId, setValue, canContinue]);

  useEffect(() => {
    setValue('authorizationTerms', authorizationTerms);
  }, [authorizationTerms, setValue]);

  return {
    email,
    userName,
    roleId,
    setRoleId,
    setAuthorizationTerms,
    showAuthorizationTerms,
    setShowAuthorizationTerms,
  };
};

export default useAssignRole;
